import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[bookshelfTemplateSubheaderActions]',
})
export class BookshelfTemplateSubheaderActionsDirective {
  constructor(public template: TemplateRef<any>) {
  }
}
